import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { collection, addDoc, setDoc, doc, getDocs} from "firebase/firestore"; 
import { db, storage } from "../firebase-config";
import Financeurs from './Financeurs';
import {v4 as uuidv4} from 'uuid'
import { IoMdCamera } from "react-icons/io";
import { FaCircleMinus } from "react-icons/fa6";

const Form = () => {

  
    const [validation, setValidation] = useState("")
    const [subbed, setSubbed] = useState([])
    const formRef = useRef()
    const [alreadyBooked, setAlreadyBooked] = useState('nothing booked already')
    const [dataReady, setDataReady] = useState('not ready')
    const [disabled, setDisabled] = useState(false)

    const horaires = ['9h', '9h30', '10h', '10h30', '11h', '13h30', '14h', '14h30', '15h']
    
    const loadAlreadySubbed = async () =>  {
      setSubbed([]);
      const ref = collection(db, 'groupe_scolaire');
      const querySnapshot = await getDocs(ref)
      querySnapshot.forEach((doc) => {
          console.log(doc.id);
        setSubbed(subbed => [doc.data(), ...subbed])
      }) 

     
    }


    const getAlreadyBooked = async () => {
      setAlreadyBooked([])
      setAlreadyBooked(subbed.map(sub => sub.CRENEAU_HORAIRE))
     
    }

    const testBooked = async () => {
      if((alreadyBooked.length > 0 && alreadyBooked.length < 8 || alreadyBooked === 'nothing booked already')) {
        setDataReady('ready')
      } else if(JSON.stringify(alreadyBooked.sort()) === JSON.stringify(horaires.sort())) {
        setDataReady('full')
        setDisabled(true)
      }
    }

    useEffect(() => {
      console.log('fire');
      loadAlreadySubbed()
    }, [])
    
    console.log(disabled);
    useEffect(() => {
      getAlreadyBooked()
    }, [subbed])

    useEffect(() => {
     testBooked()
    }, [alreadyBooked])
  
    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
          mode: 'onChange',
          defaultValues: "",
    })

    console.log(alreadyBooked);

    console.log(dataReady);

    const onSubmit = async data  => {

        var id = uuidv4()
        var etablissement = "/";     
        var nom = "/";
        var prenom = "/";
        var email = "/";
        var tel = "/";
        var creneau_horaire = "/";
        var niveau_eleves = "/";
        var commentaire = "/";
    

                
      if(data.etablissement) {
        etablissement = data.etablissement
      } 
                
      if(data.nom) {
        nom = data.nom
      } 
      if(data.prenom) {
        prenom = data.prenom
      } 
                
      if(data.email) {
        email = data.email
      } 
                
      if(data.tel) {
        tel = data.tel
      } 
      if(data.creneau_horaire) {
        creneau_horaire = data.creneau_horaire
      } 
      if(data.niveau_eleves) {
        niveau_eleves = data.niveau_eleves
      }

      if(data.commentaire) {
        commentaire = data.commentaire
      }
 


    try {

        const preSubInfo = {
          ID: id, 
          ETABLISSEMENT: etablissement,
          NOM: nom,
          PRENOM: prenom,
          EMAIL: email,
          TELEPHONE: tel,
          CRENEAU_HORAIRE: creneau_horaire,
          NIVEAU_ELEVES: niveau_eleves,
          COMMENTAIRE: commentaire,
          DATE: new Date().toLocaleString()   
        }
        console.log(preSubInfo)

        console.log(data)
        const ref = doc(db, "groupe_scolaire", id);
        const docRef = setDoc(ref, preSubInfo)
        setValidation(["Vos réponses ont bien été enregistrées !", "Success"])
  

      }
              catch(err) {
              console.log(err);
              setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])

          }
      
          formRef.current.reset("");
          setDataReady('not ready')
          setDisabled(true)
          
}
    return (
        <>
         
            <div className="container">

           
            
                 <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
                    {validation && <div className={ validation[1] === "Success" ? "success" : "error"}>{validation[0]}</div>}
                  
                   
                    <h4 className='required'>Les champs marqués d'un * sont requis</h4>
                        <input {...register('etablissement', {required: true})} type="text" name="etablissement" id="" placeholder="établissement *"/>
                        {errors.structure?.type === "required" && (
                               <small>Ce champ est requis</small>
                          )}

                        <div className="contact">
                        <input {...register('nom', {required: true})} type="text" name="nom" id="" placeholder='Nom *'/>
                        {errors.nom?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                        <input {...register('prenom', {required: true})} type="text" name="prenom" id="" placeholder='Prénom *'/>
                        {errors.prenom?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                        <input {...register('email', {required: true})} type="email" name="email" id="" placeholder='Courriel *'/>
                        {errors.email?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                        <input {...register('tel', {required: true})} type="tel" name="tel" id="" placeholder='Téléphone *'/>
                        {errors.tel?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                          
                        </div>
                       
                    {dataReady === 'ready' ?
                    <div className="creneauxHoraires">
                        <h4 htmlFor="">Choisissez un créneau horaire : *</h4>
                        <div className="matin">
                          {alreadyBooked.includes('9h') ? 
                          <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} disabled id="" value="9h"/>
                            <label>9h <em>Ce créneau est déjà réservé</em></label> 
                          </div>
                          :
                          <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="9h"/>
                            <label>9h</label>
                          </div> 
                          }
                          {alreadyBooked.includes('9h30') ? 
                            <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio" className='disabled' {...register('creneau_horaire', {required: true})} disabled id="" value="9h30"/>
                            <label>9h30 <em>Ce créneau est déjà réservé</em></label>
                            </div> :
                            <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="9h30"/>
                            <label>9h30</label>
                            </div>
                          }
                          {alreadyBooked.includes('10h') ? 
                            <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio" className='disabled' {...register('creneau_horaire', {required: true})} disabled id="" value="10h"/>
                            <label>10h <em>Ce créneau est déjà réservé</em></label>
                            </div> :
                            <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="10h"/>
                            <label>10h</label>
                            </div>
                          }
                          {alreadyBooked.includes('10h30') ? 
                            <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio" className='disabled' {...register('creneau_horaire', {required: true})} disabled id="" value="10h30"/>
                            <label>10h30 <em>Ce créneau est déjà réservé</em></label>
                            </div> :
                            <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="10h30"/>
                            <label>10h30</label>
                            </div>
                          }
                          {alreadyBooked.includes('11h') ? 
                            <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio" className='disabled' {...register('creneau_horaire', {required: true})} disabled id="" value="11h"/>
                            <label>11h <em>Ce créneau est déjà réservé</em></label>
                            </div> :
                            <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="11h"/>
                            <label>11h</label>
                            </div>
                          }
                       </div>
                       <div className="apresMidi">
                       {alreadyBooked.includes('13h30') ? 
                          <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} disabled id="" value="13h30"/>
                            <label>13h30 <em>Ce créneau est déjà réservé</em></label> 
                          </div>
                          :
                          <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="13h30"/>
                            <label>13h30</label>
                          </div> 
                          }
                         {alreadyBooked.includes('14h') ? 
                          <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} disabled id="" value="14h"/>
                            <label>14h <em>Ce créneau est déjà réservé</em></label> 
                          </div>
                          :
                          <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="14h"/>
                            <label>14h</label>
                          </div> 
                          }
                        {alreadyBooked.includes('14h30') ? 
                          <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} disabled id="" value="14h30"/>
                            <label>14h30 <em>Ce créneau est déjà réservé</em></label> 
                          </div>
                          :
                          <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="14h30"/>
                            <label>14h30</label>
                          </div> 
                          }
                         {alreadyBooked.includes('15h') ? 
                          <div title="Ce créneau est déjà réservé" className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} disabled id="" value="15h"/>
                            <label>15h <em>Ce créneau est déjà réservé</em></label> 
                          </div>
                          :
                          <div className="radio">
                            <input type="radio"  {...register('creneau_horaire', {required: true})} id="" value="15h"/>
                            <label>15h</label>
                          </div> 
                          }
                        </div>
                        {errors.seraPresent?.type === "required" && (
                          <small>Ce champ est requis</small>
                        )}
                      </div> 

                      : dataReady === 'full' ? 
                        <p>Tous les créneaux proposés pour les groupes ont déjà été réservés.<br/>
                          Merci pour l’intérêt que vous portez à Agora Jobs</p>
                      : ""
                      }
                    <div className="niveau_eleves">
                        <h4 htmlFor="">Niveau des élèves : *</h4>
                        <div className="answers">
                        <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="CAP"/>
                            <label>CAP</label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="5 ème"/>
                            <label>5 <sup>e</sup></label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="4 ème"/>
                            <label>4 <sup>e</sup></label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="3 ème"/>
                            <label>3 <sup>e</sup></label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="Seconde"/>
                            <label>Seconde</label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="Première"/>
                            <label>Première</label>
                          </div>
                          <div className="chx">
                            <input type="checkbox"  {...register('niveau_eleves', {required: true})} name="niveau_eleves" id="" value="Terminale"/>
                            <label>Terminale</label>
                          </div>
                       </div>
                    </div>
                    <textarea {...register('commentaire')} name="commentaire" id="" placeholder='Commentaire (facultatif)'></textarea>
                      {disabled === true ? 
                      <button disabled className="btn not_allowed" id="button">Envoyer</button> 
                      :
                      <button className="btn" id="button">Envoyer</button> 
                      }
                     
                    </form>
                    <Financeurs /> 
                </div>
     
        </>
    );
};

export default Form;